export default __webpack_public_path__ + "static/media/sharpgrotesk-medium20-webfont.a35f4fff.woff2";